import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class SuppliersEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      supplier_certifications: [],
      country_list: [],
      id: this.props.supplier_id,
      name: this.props.supplier_data.name,
      address: this.props.supplier_data.address,
      city: this.props.supplier_data.city,
      province: this.props.supplier_data.province,
      country_id: this.props.supplier_data.country_id,
      zipcode: this.props.supplier_data.zipcode,
      phone: this.props.supplier_data.phone,
      email: this.props.supplier_data.email,
      observations: this.props.supplier_data.observations,
    };

    this.locale = getLocale();

    //bind específico
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.supplier_data.name !== 'undefined') {
      this.setState({
        id: newProps.supplier_id,
        name: newProps.supplier_data.name,
        address: newProps.supplier_data.address,
        city: newProps.supplier_data.city,
        province: newProps.supplier_data.province,
        country_id: newProps.supplier_data.country_id,
        zipcode: newProps.supplier_data.zipcode,
        phone: newProps.supplier_data.phone,
        email: newProps.supplier_data.email,
        observations: newProps.supplier_data.observations,
      });
    }
    if(Array.isArray(newProps.country_list)) {
      this.setState({country_list: newProps.country_list});
    }
  }
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      address: this.state.address,
      city: this.state.city,
      province: this.state.province,
      country_id: this.state.country_id,
      zipcode: this.state.zipcode,
      phone: this.state.phone,
      email: this.state.email,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fornecedor', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div>
    <form onSubmit={this.edit}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Nome}:</label>
            <input type="text" name="name" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.NomeDoFornecedor} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Endereco}:</label>
            <input type="text" name="address" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.EnderecoDoFornecedor} value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Cidade}:</label>
            <input type="text" name="city" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.CidadeDoFornecedor} value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Estado}:</label>
            <input type="text" name="province" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.EstadoProvinciaDoFornecedor} value={this.state.province} onChange={this.handleChange.bind(this, 'province')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Pais}:</label>
            <Select
              className="form-field-name"
              name="country_id"
              value={this.state.country_id}
              searchable={true}
              placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.SelecionarPais}
              onChange={this.handleSelectChange.bind(this, 'country_id')}
              options={this.state.country_list}
            />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.CEP}:</label>
            <InputMask value={this.state.zipcode}  maskChar={null} name="zipcode" mask="99999-999" className="form-control" onChange={this.handleChange.bind(this, 'zipcode')} placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.CEPDoFornecedor} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Telefone}:</label>
            <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.TelefoneDoFornecedor} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Email}:</label>
            <input type="text" name="email" className="form-control" placeholder={this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.placeholder.EmailDoFornecedor} value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label>{this.locale.Fornecedores.EditarFornecedor.tabDadosDoFornecedor.formulario.Observacoes}:</label>
            <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
        </div>
      </div>
    </form>
  </div>
</div>
    );
  }
}

export default SuppliersEditTab;



// WEBPACK FOOTER //
// ./src/Components/Suppliers/Elements/SuppliersEditTab.js